<template>
  <div>
    <div
      style="position: fixed; top: 20px; z-index: 1; backdrop-filter: blur(2px)"
      v-if="LoaderStatus"
    >
      <Spinner />
    </div>
    <div class="main-container">
      <div
        class="page-heading d-flex justify-content-between align-items-center"
      >
        <div class="main-head">
          <span>Upload Documents</span>
        </div>
      </div>
      <div class="d-flex justify-content-between align-items-center mt-3">
        <div style="width: 70%" class="up-docs-container">
          <div
            v-if="documentDetails.length == 0"
            class="d-flex justify-content-center align-items-center"
            style="height: 100%"
          >
            <img src="../../../assets/no-Doc.svg" alt="" />
          </div>
          <div v-else>
            <div
              class="resume-container mt-2 mr-3 d-flex justify-content-between"
              v-for="(i, index) in documentDetails"
              :key="index"
            >
              <div class="mt-2 d-flex align-items-center position-relative">
                <div class="udoc-blue"></div>
                <img
                  src="../../../assets/pdficon.svg"
                  alt=""
                  class="mr-2 mb-1"
                />
                <span class="document-text">
                  {{ i.documentName | convertToString }}</span
                >
              </div>
              <div class="mt-2 mr-5 d-flex align-items-center">
                <div class="mr-5 pointer" @click="openPreview(i)">
                  <img src="../../../assets/img/hrportal/eyeicon.svg" alt="" />
                  <span class="delete-text ml-2"> Preview</span>
                </div>
                <div class="pointer" @click="openDocumentModal(i)">
                  <img
                    src="../../../assets/img/workbench/deleteicon.svg"
                    alt=""
                  />
                  <span class="delete-text ml-2"> Delete</span>
                </div>

                <div class="ml-5">
                  <img src="../../../assets/upload.svg" alt="" class="" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 30%" class="ml-1 assign-upper-container">
          <div class="doc-text mt-2">Declaration Documents</div>
          <div class="assign-below-container mt-3">
            <div class="">
              <div class="topDiv mt-3">
                <label class="fieldsetStyle"
                  >Document Name &nbsp;<span class="asterik">*</span></label
                >
                <b-form-input
                  class="inputField"
                  id="input-1"
                  placeholder="Enter Document name"
                  v-model.trim="$v.name.$model"
                  :class="{ error: $v.name.$error }"
                >
                </b-form-input>
                <div
                  class="validationicon"
                  v-if="$v.name.$dirty && !$v.name.required"
                  v-b-popover.hover.top.v-danger="{ content: 'Required' }"
                >
                  <img src="../../../assets/deletepopupicon.svg" alt="" />
                </div>
              </div>
              <div
                class="up-dot-main mt-5"
                :class="
                  !filePresent
                    ? 'up-dot-bg'
                    : fileFailed
                    ? 'up-dot-fail'
                    : 'up-dot-wait'
                "
              >
                <div
                  class="dot-align relativeclass"
                  v-if="filePresent == false"
                >
                  <input
                    @change="previewDocuments"
                    type="file"
                    multiple
                    class="pointer inputimage"
                  />
                  <div class="drop-txt">
                    <span class="up-screen-txt">Upload Document</span>
                    <span class="asterik">&nbsp;*</span>
                  </div>
                  <div class="size">
                    <span class="up-max"
                      >Max size : 5mb, Supported Format : PDF</span
                    >
                  </div>
                </div>
                <div
                  v-else-if="fileFailed"
                  class="
                    d-flex
                    align-items-center
                    justify-content-between
                    ml-3
                    w-100
                    mr-3
                  "
                >
                  <div class="d-flex">
                    <img src="../../../assets/pdficon.svg" alt="pdf" />
                    <div class="d-flex flex-column align-items-start ml-2">
                      <div class="up-uploaded-filename">{{ fileName }}</div>
                      <div class="up-file-failed">
                        {{
                          failReason == "size"
                            ? "File must not exceed 5mb"
                            : "Invalid Format"
                        }}
                      </div>
                    </div>
                  </div>
                  <div class="pointer" @click="removeFile">
                    <img
                      src="../../../assets/img/createjd/fedbckclose.svg"
                      alt=""
                    />
                  </div>
                </div>
                <div
                  v-else
                  class="
                    d-flex
                    align-items-center
                    justify-content-between
                    ml-3
                    w-100
                    mr-3
                  "
                >
                  <div class="d-flex">
                    <div>
                      <img src="../../../assets/pdficon.svg" alt="pdf" />
                    </div>
                    <div class="up-uploaded-filename ml-2">
                      {{ fileName }}
                    </div>
                  </div>
                  <div class="pointer" @click="removeFile">
                    <img
                      src="../../../assets/img/createjd/fedbckclose.svg"
                      alt=""
                    />
                  </div>
                </div>
              </div>
              <div>
                <b-button
                  :disabled="!filePresent || name == ''"
                  @click="postDocuments()"
                  class="addbtn addcustvendbtn udoc-button"
                >
                  <img src="../../../assets/Group (6).svg" alt="" />
                  <span class="ml-2"> Upload Document</span>
                </b-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="delDocument" centered hide-footer hide-header @hidden="$bvModal.hide('delDocument')">
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        Caution
        <img src="../../../assets/deletepopupicon.svg" alt="" />
      </div>
      <div @click="$bvModal.hide('delDocument')" class="xMarkCancel">
        <img src="../../../assets/xmark.svg" alt="" />
      </div>
      <hr />
      <div class="mt-3 wrdbrk testconfig-card-name">
        <span>Are you sure you want to delete "{{ docName }}"</span>
      </div>
      <div>
        <span class="asterik">*</span
        ><span class="testconfig-card-name"
          >Please note this action cannot be undone</span
        >
      </div>
      <div class="d-flex align-items-center justify-content-end mt-3">
        <b-button class="addbtn" @click="deleteDocuments(docID)"
          >Delete</b-button
        >
      </div>
    </b-modal>

    <b-modal
      id="document"
      centered
      hide-footer
      hide-header
      class="p-0"
      size="lg"
      @hidden="$bvModal.hide('document')"
    >
      <div
        class="modalheading d-flex align-items-center justify-content-between"
      >
        <span class="caution-txt">{{ viewDoc.documentName }}</span>
      </div>
      <hr />
      <div class="xMarkCancel" @click="$bvModal.hide('document')">
        <img src="../../../assets/cross-round.svg" alt="" />
      </div>

      <div class="canddocslist">
        <b-pagination
          v-model="currentPage"
          :total-rows="numPages"
          :per-page="perPage"
          align="center"
          first-number
          last-number
        >
          <template #prev-text
            ><span
              ><img
                src="../../../assets/img/hrportal/leftvector.svg"
                alt=""
              /> </span
          ></template>
          <template #next-text
            ><span
              ><img
                src="../../../assets/img/hrportal/rightarrow.svg"
                alt="" /></span
          ></template>
        </b-pagination>
        <div>
          <pdf
            ref="pdf"
            style="border: 1px solid black"
            :src="viewDoc.source"
            :page="currentPage"
            @num-pages="numPages = $event"
            @link-clicked="currentPage = $event"
            @page-loaded="currentPage = $event"
          ></pdf>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import {
  uploaddocuments,
  getuploaddocuments,
  deleteuploaddocuments,
} from "../../../utils/apiFunctions";
import pdf from "vue-pdf";
import { required } from "vuelidate/lib/validators";
import toast from "../../../components/mixin/toast";
import Spinner from "../../../components/fixedcomponents/Spinner.vue";

export default {
  name: "UploadDocuments",
  components: {
    pdf,
    Spinner,
  },
  mixins: [toast],

  data() {
    return {
      // BOOLEAN
      LoaderStatus: false,

      fileFailed: false,
      filePresent: false,

      // STRINGS
      name: "",
      failReason: "",
      fileData: "",
      docName: "",
      fileName: "",
      sourceKey: "",
      docID: "",

      // NUMBERS
      numPages: 0,
      currentPage: 1,
      perPage: 1,

      // OBJECTS
      viewDoc: {},

      // ARRAYS
      documentDetails: [],
    };
  },
  validations: {
    name: {
      required,
    },
  },
  created() {
    this.getDocuments();
  },
  filters: {
    convertToString: function (value) {
      const result = value.replace(/([A-Z])/g, " $1");
      return result.charAt(0).toUpperCase() + result.slice(1);
    },
  },
  methods: {
    // ASYNCHRONOUS BLOCK
    // GET ALL DOCUMENTS
    async getDocuments() {
      try {
        const res = await getuploaddocuments();
        if (res.status == 200) {
          this.documentDetails = res.data.data;
        }
        this.LoaderStatus = false;
      } catch (error) {
        console.error(error);
      }
    },

    // POST DOCUMENT
    postDocuments() {
      this.LoaderStatus = true;
      this.$v.$touch();
      if (this.fileFailed) {
        this.fileError = true;
        if (this.failReason == "size") {
          this.errorModal("File size is too large");
        } else if (this.failReason == "format") {
          this.errorModal("Upload supported format");
        }
      } else if (!this.filePresent) {
        this.fileError = true;
        this.errorModal("Please select a document");
      } else if (!this.$v.$invalid && !this.fileError) {
        let formData = new FormData();
        formData.append("documentName", this.name);
        formData.append("source", this.sourceKey);
        uploaddocuments(formData)
          .then((res) => {
            if (res.status == 200) {
              this.successModal("Document Uploaded Successfully");
              this.name = "";
              this.$v.$reset();
              this.removeFile();
              this.getDocuments();
            }
          })
          .catch((err) => {
            this.errorModal("Something went wrong!");
            throw err;
          });
      }
    },

    //Edit Document
    editDoc(data) {
      this.name = data.documentName;
      this.fileName = data.documentName;
      this.fileData = data.source;
      this.fileFailed = false;
      this.filePresent = true;
      this.failReason = "";
      this.sourceKey = data.source;
      this.docID = data.documentID;
    },

    // DELETE DOCUMENT
    deleteDocuments(data) {
      let documentID = [];
      documentID.push(data);
      let payload = {
        documentIDs: documentID,
      };

      deleteuploaddocuments(payload)
        .then((res) => {
          if (res.status == 200) {
            this.$bvModal.hide("delDocument");
            this.successModal("Document deleted Successfully");
            this.getDocuments();
            this.documentDetails = this.documentDetails.filter(
              ({ documentName }) => documentName != data
            );
          }
        })
        .catch((err) => {
          this.errorModal("Something went wrong!");
          throw err;
        });
    },

    // HELPER FUNCTIONS
    // CHECK DOCUMENT AND BINARY CONVERSION
    previewDocuments: function (event) {
      this.fileName = "";
      let input = event.target;
      let pdfcheck = input.files[0];

      if (!pdfcheck.type.includes("pdf")) {
        this.fileFailed = true;
        this.fileData = "";
        this.filePresent = true;
        this.failReason = "format";
      } else if (event.target.files[0].size > 5000000) {
        this.fileFailed = true;
        this.fileData = "";
        this.filePresent = true;
        this.failReason = "size";
      } else if (input?.files[0]) {
        this.fileName = input.files[0].name;
        let reader = new FileReader();
        reader.readAsDataURL(input.files[0]);
        this.fileData = input.files[0];
        this.fileFailed = false;
        this.filePresent = true;
        this.failReason = "";
        this.sourceKey = input.files[0];
        this.$forceUpdate();
      }
    },

    // OPEN DELETE DOCUMENT MODAL
    openDocumentModal(i) {
      this.docName = i.documentName;
      this.docID = i.documentID;
      this.$bvModal.show("delDocument");
    },

    // OPEN PREVIEW DOCUMENT MODAL
    openPreview(doc) {
      this.viewDoc = doc;
      this.$bvModal.show("document");
    },

    // REMOVE FILE
    removeFile() {
      this.fileName = "";
      this.fileFailed = false;
      this.fileData = "";
      this.filePresent = false;
      this.failReason = "";
    },

    // PDF VIEW ERROR HANDLER
    // error: function (err) {
    // },

    // CAMEL CASE CONVERTER
    toCamelCase(str) {
      let arr = str.match(/[a-z]+|\d+/gi);
      return arr.map((m, i) => {
        let low = m.toLowerCase();
        if (i != 0) {
          low = low.split("").map((s, k) => (k == 0 ? s.toUpperCase() : s))
            .join``;
        }
        return low;
      }).join``;
    },
  },
};
</script>

<style>
.canddocslist li {
  display: none;
}

.canddocslist {
  position: relative;
}

.canddocslist ul {
  display: flex;
  justify-content: space-between !important;
}

.canddocslist li:first-child {
  display: block;
  position: absolute;
  top: 40%;
  left: -10px;
  z-index: 65;
}

.canddocslist li:last-child {
  display: block;
  position: absolute;
  top: 40%;
  right: -10px;
  z-index: 65;
}

.up-docs-container {
  height: calc(100vh - 180px);
  overflow: auto;
}

.up-file-failed {
  font-weight: 400;
  font-size: 12px;
  color: #d90606;
}

.up-uploaded-filename {
  font-weight: 600;
  font-size: 16px;
  color: #565656;
}

.up-dot-wait {
  background: #fbfbfb;
  border: 0.5px solid #c4c4c4;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.up-dot-fail {
  border: 0.5px solid #e45353;
  border-radius: 5px;
  display: flex;
  align-items: center;
}

.up-dot-main {
  text-align: center;
  padding: 1px;
}

.up-dot-bg {
  background-image: url("data:image/svg+xml,%3csvg width='100%25' height='100%25' xmlns='http://www.w3.org/2000/svg'%3e%3crect width='100%25' height='100%25' fill='none' rx='13' ry='13' stroke='%2372738EFF' stroke-width='4' stroke-dasharray='6%2c 14' stroke-dashoffset='18' stroke-linecap='square'/%3e%3c/svg%3e");
  border-radius: 13px;
}

.up-screen-txt {
  font-weight: 600;
  font-size: 16px;
  color: #72738e;
}

.up-max {
  font-weight: 400;
  font-size: 14px;
  color: #72738e;
}

.assign-upper-container {
  height: calc(100vh - 180px);
  background: #ffffff;
  box-shadow: 0px 4px 20px rgba(196, 196, 196, 0.5);
  border-radius: 8px;
  padding: 10px;
  position: relative;
}

.assign-below-container {
  height: calc(100vh - 250px);
  background: #fbfbfb;
  padding: 15px;
}

.doc-text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  color: #72738e;
}

.upload-text {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  color: #72738e;
}

.inputimage-false {
  position: absolute;
  width: 100%;
  height: 50%;
  left: 0;
  top: 0;
}

.inputimage {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
}

input[type="file"] {
  opacity: 0;
}

.resume-container {
  background: #f6f6fc;
  border-radius: 5px;
  padding: 10px;
}

.document-text {
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #565656;
}

.delete-text {
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  /* identical to box height */

  text-decoration-line: underline;

  color: #72738e;
}

.udoc-button {
  position: absolute;
  bottom: 30px;
  right: 20px;
}

.udoc-blue {
  width: 2px;
  background: #00bad9;
  position: absolute;
  height: 49px;
  left: -7px;
  top: -12px;
}
</style>
